export const IOSTemplates = {
  contentsJson: `{
  "images": [
    {
      "idiom": "universal",
      "scale": "1x",
      "filename": "LaunchImage.png"
    },
    {
      "idiom": "universal",
      "scale": "2x",
      "filename": "LaunchImage@2x.png"
    },
    {
      "idiom": "universal",
      "scale": "3x",
      "filename": "LaunchImage@3x.png"
    }
  ],
  "info": {
    "version": 1,
    "author": "xcode"
  }
}`,

  contentsJsonDark: `{
  "images": [
    {
      "idiom": "universal",
      "scale": "1x",
      "filename": "LaunchImage.png"
    },
    {
      "idiom": "universal",
      "scale": "2x",
      "filename": "LaunchImage@2x.png"
    },
    {
      "idiom": "universal",
      "scale": "3x",
      "filename": "LaunchImage@3x.png"
    },
    {
      "idiom": "universal",
      "scale": "1x",
      "filename": "LaunchImageDark.png",
      "appearances": [
        {
          "appearance": "luminosity",
          "value": "dark"
        }
      ]
    },
    {
      "idiom": "universal",
      "scale": "2x",
      "filename": "LaunchImageDark@2x.png",
      "appearances": [
        {
          "appearance": "luminosity",
          "value": "dark"
        }
      ]
    },
    {
      "idiom": "universal",
      "scale": "3x",
      "filename": "LaunchImageDark@3x.png",
      "appearances": [
        {
          "appearance": "luminosity",
          "value": "dark"
        }
      ]
    }
  ],
  "info": {
    "version": 1,
    "author": "xcode"
  }
}`,

  brandingContentsJson: `{
  "images": [
    {
      "idiom": "universal",
      "scale": "1x",
      "filename": "BrandingImage.png"
    },
    {
      "idiom": "universal",
      "scale": "2x",
      "filename": "BrandingImage@2x.png"
    },
    {
      "idiom": "universal",
      "scale": "3x",
      "filename": "BrandingImage@3x.png"
    }
  ],
  "info": {
    "version": 1,
    "author": "xcode"
  }
}`,

  brandingContentsJsonDark: `{
  "images": [
    {
      "idiom": "universal",
      "scale": "1x",
      "filename": "BrandingImage.png"
    },
    {
      "idiom": "universal",
      "scale": "2x",
      "filename": "BrandingImage@2x.png"
    },
    {
      "idiom": "universal",
      "scale": "3x",
      "filename": "BrandingImage@3x.png"
    },
    {
      "idiom": "universal",
      "scale": "1x",
      "filename": "BrandingImageDark.png",
      "appearances": [
        {
          "appearance": "luminosity",
          "value": "dark"
        }
      ]
    },
    {
      "idiom": "universal",
      "scale": "2x",
      "filename": "BrandingImageDark@2x.png",
      "appearances": [
        {
          "appearance": "luminosity",
          "value": "dark"
        }
      ]
    },
    {
      "idiom": "universal",
      "scale": "3x",
      "filename": "BrandingImageDark@3x.png",
      "appearances": [
        {
          "appearance": "luminosity",
          "value": "dark"
        }
      ]
    }
  ],
  "info": {
    "version": 1,
    "author": "xcode"
  }
}`,

  launchBackgroundJson: `{
  "images": [
    {
      "idiom": "universal",
      "filename": "background.png"
    }
  ],
  "info": {
    "version": 1,
    "author": "xcode"
  }
}`,

  launchBackgroundDarkJson: `{
  "images": [
    {
      "idiom": "universal",
      "filename": "background.png"
    },
    {
      "idiom": "universal",
      "filename": "darkbackground.png",
      "appearances": [
        {
          "appearance": "luminosity",
          "value": "dark"
        }
      ]
    }
  ],
  "info": {
    "version": 1,
    "author": "xcode"
  }
}`,

  launchScreenStoryboard: `<?xml version="1.0" encoding="UTF-8"?>
<document type="com.apple.InterfaceBuilder3.CocoaTouch.Storyboard.XIB" version="3.0" toolsVersion="17156" targetRuntime="iOS.CocoaTouch" propertyAccessControl="none" useAutolayout="YES" launchScreen="YES" useTraitCollections="YES" useSafeAreas="YES" colorMatched="YES" initialViewController="01J-lp-oVM">
    <device id="retina6_1" orientation="portrait" appearance="light"/>
    <dependencies>
        <deployment identifier="iOS"/>
        <plugIn identifier="com.apple.InterfaceBuilder.IBCocoaTouchPlugin" version="17126"/>
        <capability name="Safe area layout guides" minToolsVersion="9.0"/>
        <capability name="documents saved in the Xcode 8 format" minToolsVersion="8.0"/>
    </dependencies>
    <scenes>
        <!--View Controller-->
        <scene sceneID="EHf-IW-A2E">
            <objects>
                <viewController id="01J-lp-oVM" sceneMemberID="viewController">
                    <view key="view" contentMode="scaleToFill" id="Ze5-6b-2t3">
                        <rect key="frame" x="0.0" y="0.0" width="414" height="896"/>
                        <autoresizingMask key="autoresizingMask" widthSizable="YES" heightSizable="YES"/>
                        <subviews>
                            <imageView clipsSubviews="YES" userInteractionEnabled="NO" contentMode="scaleAspectFit" horizontalHuggingPriority="251" verticalHuggingPriority="251" image="[LAUNCH_IMAGE_PLACEHOLDER]" translatesAutoresizingMaskIntoConstraints="NO" id="YRO-k0-Ey4">
                                <rect key="frame" x="0.0" y="0.0" width="414" height="896"/>
                            </imageView>
                        </subviews>
                        <viewLayoutGuide key="safeArea" id="Bcu-3y-fUS"/>
                        <color key="backgroundColor" red="1" green="1" blue="1" alpha="1" colorSpace="custom" customColorSpace="sRGB"/>
                    </view>
                </viewController>
                <placeholder placeholderIdentifier="IBFirstResponder" id="iYj-Kq-Ea1" userLabel="First Responder" sceneMemberID="firstResponder"/>
            </objects>
            <point key="canvasLocation" x="53" y="375"/>
        </scene>
    </scenes>
    <resources>
        <image name="[LAUNCH_IMAGE_PLACEHOLDER]" width="0.5" height="0.5"/>
    </resources>
</document>`,

  brandingSubview: `<imageView clipsSubviews="YES" userInteractionEnabled="NO" contentMode="scaleAspectFit" horizontalHuggingPriority="251" verticalHuggingPriority="251" image="[BRANDING_IMAGE_PLACEHOLDER]" translatesAutoresizingMaskIntoConstraints="NO" id="YRO-k1-Ey4">
    <rect key="frame" x="0.0" y="0.0" width="414" height="896"/>
</imageView>`,

  launchBackgroundConstraints: `<constraints>
    <constraint firstItem="YRO-k0-Ey4" firstAttribute="centerX" secondItem="Ze5-6b-2t3" secondAttribute="centerX" id="1Gr-gV-wFs"/>
    <constraint firstItem="YRO-k0-Ey4" firstAttribute="centerY" secondItem="Ze5-6b-2t3" secondAttribute="centerY" id="4X2-HB-R7a"/>
    <constraint firstItem="YRO-k0-Ey4" firstAttribute="leading" secondItem="Ze5-6b-2t3" secondAttribute="leading" id="SdS-ul-q2q"/>
    <constraint firstAttribute="trailing" secondItem="YRO-k0-Ey4" secondAttribute="trailing" id="Swv-Gf-Rwn"/>
    <constraint firstAttribute="bottom" secondItem="YRO-k0-Ey4" secondAttribute="bottom" id="Y44-ml-fuU"/>
    <constraint firstItem="YRO-k0-Ey4" firstAttribute="top" secondItem="Ze5-6b-2t3" secondAttribute="top" id="moa-c2-u7t"/>
</constraints>`,

  brandingCenterBottomConstraints: `<constraints>
    <constraint firstItem="Bcu-3y-fUS" firstAttribute="bottom" secondItem="YRO-k1-Ey4" secondAttribute="bottom" constant="{bottom_padding}" id="7fp-q4-alv"/>
    <constraint firstItem="YRO-k1-Ey4" firstAttribute="centerX" secondItem="Ze5-6b-2t3" secondAttribute="centerX" id="qky-c2-u7t"/>
</constraints>`,

  brandingLeftBottomConstraints: `<constraints>
    <constraint firstItem="Bcu-3y-fUS" firstAttribute="bottom" secondItem="YRO-k1-Ey4" secondAttribute="bottom" constant="{bottom_padding}" id="7fp-q4-alv"/>
    <constraint firstItem="YRO-k1-Ey4" firstAttribute="leading" secondItem="Ze5-6b-2t3" secondAttribute="leading" id="qky-c2-u7t"/>
</constraints>`,

  brandingRightBottomConstraints: `<constraints>
    <constraint firstItem="Bcu-3y-fUS" firstAttribute="bottom" secondItem="YRO-k1-Ey4" secondAttribute="bottom" constant="{bottom_padding}" id="7fp-q4-alv"/>
    <constraint firstAttribute="trailing" secondItem="YRO-k1-Ey4" secondAttribute="trailing" id="qky-c2-u7t"/>
</constraints>`,
};
